// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gallery {
    background-color: #EEE;
    margin-top: 1.5rem;
    margin-bottom: 2.5rem;
}

.gallery-cell {
    width: 100%;
    aspect-ratio: 4 / 5;
    overflow: hidden;
}

.gallery-cell img {
    width:100%;
    height:100%;
    object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/Carousel/carousel.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB","sourcesContent":[".gallery {\n    background-color: #EEE;\n    margin-top: 1.5rem;\n    margin-bottom: 2.5rem;\n}\n\n.gallery-cell {\n    width: 100%;\n    aspect-ratio: 4 / 5;\n    overflow: hidden;\n}\n\n.gallery-cell img {\n    width:100%;\n    height:100%;\n    object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
